<!-- 确认开门提示 -->
<template>
    <van-popup
        :value="value"
        position="bottom"
        round
        safe-area-inset-bottom
        :close-on-click-overlay="true"
        class="confirm-unlock-popup"
        @input="$emit('input', $event)"
        @click-overlay="handleDismiss"
    >
        <div class="sheet">
            <div class="icon-wrap" aria-hidden="true">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M7 11V8a5 5 0 019.9-1" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/>
                    <rect x="5" y="11" width="14" height="10" rx="2" stroke="currentColor" stroke-width="1.8"/>
                    <circle cx="12" cy="16" r="1.4" fill="currentColor"/>
                </svg>
            </div>
            <p class="room-line">{{ roomLine }}</p>
            <h2 class="title">确认开启会议室门锁?</h2>
            <p class="desc">
                门禁仅在预约有效期前后 5 分钟内可用，请确认你已到达门口。
            </p>
            <button
                class="btn-primary"
                type="button"
                :disabled="submitting"
                @click="handleConfirm"
            >
                确认开门
            </button>
            <button class="btn-text" type="button" @click="handleDismiss">
                暂不开门
            </button>
        </div>
    </van-popup>
</template>

<script>

import { openDoorRequest } from '@/request/api'
import { isUnauthorizedError } from '@/tools/utils'
import { Toast } from 'vant'

export default {
    name: 'confirmUnlock',
    props: {
        value: {
            type: Boolean,
            default: false,
        },
        reservationId: {
            type: [String, Number],
            default: '',
        },
        roomName: {
            type: String,
            default: '',
        },
        floor: {
            type: String,
            default: '',
        },
    },
    data() {
        return {
            submitting: false,
        }
    },
    computed: {
        roomLine() {
            const name = this.roomName || '会议室'
            const floor = String(this.floor || '').trim()
            return floor ? `${name}(${floor})` : name
        },
    },
    methods: {
        handleConfirm() {
            if (this.submitting) return
            this.submitting = true
            Toast.loading({
                message: '开门中...',
                forbidClick: true,
                duration: 0,
            })
            openDoorRequest({ reservationId: this.reservationId })
                .then(() => {
                    this.$toast && this.$toast('开门成功')
                    this.$emit('confirm')
                    this.$emit('input', false)
                })
                .catch((err) => {
                    if (isUnauthorizedError(err)) return
                    const msg = (err && (err.message || err.msg)) || '开门失败'
                    this.$toast && this.$toast(msg)
                })
                .finally(() => {
                    this.submitting = false
                    Toast.clear()
                })
        },
        handleDismiss() {
            this.$emit('cancel')
            this.$emit('input', false)
        },
    },
}
</script>

<style scoped>
.confirm-unlock-popup {
    background: transparent;
}

.sheet {
    padding: 0.48rem 0.4rem calc(0.4rem + env(safe-area-inset-bottom));
    background: #ffffff;
    text-align: center;
    box-sizing: border-box;
}

.icon-wrap {
    width: 0.88rem;
    height: 0.88rem;
    margin: 0 auto 0.28rem;
    border-radius: 0.2rem;
    background: #e8f1ff;
    color: #2b7de9;
    display: flex;
    align-items: center;
    justify-content: center;
}

.icon-wrap svg {
    width: 0.44rem;
    height: 0.44rem;
}

.room-line {
    margin: 0 0 0.2rem;
    font-size: 0.24rem;
    line-height: 1.4;
    color: #2b7de9;
    font-weight: 500;
}

.title {
    margin: 0 0 0.2rem;
    font-size: 0.4rem;
    font-weight: 700;
    line-height: 1.35;
    color: #1e3a5f;
}

.desc {
    margin: 0 auto 0.4rem;
    max-width: 5.6rem;
    font-size: 0.24rem;
    line-height: 1.55;
    color: #8a9bb0;
}

.btn-primary {
    display: block;
    width: 100%;
    height: 0.88rem;
    border: none;
    border-radius: 0.16rem;
    background: #2b7de9;
    color: #ffffff;
    font-size: 0.3rem;
    font-weight: 600;
    line-height: 1;
    cursor: pointer;
    box-shadow: 0 0.12rem 0.28rem rgba(43, 125, 233, 0.28);
}

.btn-primary:disabled {
    background: #a8c4e8;
    cursor: not-allowed;
    box-shadow: none;
}

.btn-primary:active {
    background: #236dce;
}

.btn-text {
    display: block;
    width: 100%;
    margin-top: 0.24rem;
    padding: 0.16rem 0;
    border: none;
    background: transparent;
    font-size: 0.28rem;
    color: #8a9bb0;
    line-height: 1.4;
    cursor: pointer;
}

.btn-text:active {
    color: #6b7c91;
}
</style>
